import {
  createSelector,
} from 'reselect';

import {
  getResourceMappedList,
} from './resources';
import {
  sortByPosition,
} from './utils';

export const getAllSortedProperties = createSelector(
  getResourceMappedList('personalProperties'),
  properties => properties
    .sort(sortByPosition),
);

export const getVisiblePersonalProperties = createSelector(
  getAllSortedProperties,
  properties => properties.filter(
    p => p.is_visible,
  ),
);

export const getVisiblePropertyOptions = createSelector(
  getVisiblePersonalProperties,
  properties => properties.map(
    p => ({
      value: p.id,
      // label: `${p.name} x ${p.default_unit.short_name}`,
      label: p.name,
    }),
  ),
);

export const getDefaultProperty = createSelector(
  getVisiblePersonalProperties,
  (properties) => {
    const property = properties[0];
    return property
      ? {
        property_unit_id: property.save_unit.id,
        personal_property_id: property.id,
        personal_property: property,
      }
      : {};
  },
);

export const getWorkoutProperties = (workoutId: number) => createSelector(
  getResourceMappedList('exerciseProperties', `workout_${workoutId}`),
  properties => properties.filter(property => property.workout_id === workoutId),
);
